<template>
  <div class="payroll-refunds-status-badge" data-testid="payroll-refunds-status-badge">
    <Tag
      v-if="status !== null && status !== undefined"
      :value="statusLabel"
      :severity="statusSeverity"
      :icon="statusIcon"
      class="status-tag"
      data-testid="payroll-refunds-status-tag"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePayrollRefunds } from '../../../composables/usePayrollRefunds';

type RefundStatus = number | string | null;

interface Props {
  status?: RefundStatus;
}

const props = withDefaults(defineProps<Props>(), {
  status: null,
});

const { t } = useI18n();
const { getStatusLabel, getStatusSeverity } = usePayrollRefunds();

// Computed
const statusLabel = computed((): string => {
  return t(getStatusLabel(props.status));
});

const statusSeverity = computed((): string => {
  return getStatusSeverity(props.status);
});

const statusIcon = computed((): string => {
  const status = parseInt(String(props.status));
  switch (status) {
    case -1:
      return 'pi pi-times-circle';
    case 0:
      return 'pi pi-clock';
    case 1:
      return 'pi pi-check-circle';
    default:
      return 'pi pi-question-circle';
  }
});
</script>

<style scoped>
.payroll-refunds-status-badge {
  display: inline-flex;
  align-items: center;
}

.status-tag {
  font-size: 0.75rem;
}
</style>
